import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-views',
  templateUrl: './views.component.html',
  styleUrls: ['./views.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ]
})
export class ViewsComponent implements OnInit, OnChanges {
  url = '';
  sanitizedUrl = '';


  @Input() activeViewNew: 'Original' | 'basic' = 'basic';

   @Input() LeadDetailsObject: any;

  @Input() searchText: any;

  @Input() usedInSite: any;

  @Input() type3: boolean = false;


  @Input() leadCommonPropertiesName: any;jsonRecieved: any;
;

  @Input() leadCommonPropertiesDisplay: any;;

  filteredUsedInSite: any = {};


  @Input() leadPropertiesName: any;;

  @Input() leadPropertiesDisplay: any;;

  filteredValuesList: any = {};


  @Input() leadAdditionalPropertiesDisplay: any;;

  @Input() leadAdditionalPropertiesName: any;;

  filteredAdditionalSpec: any = {};

  originalSpec: any = {};

    @Input() additionalSpec: any;

      @Input() valuesList : any;

  ngOnInit(): void {
    // initialize filtered view

      this.jsonRecieved = this.LeadDetailsObject.jsonRecieved;

    console.log(this.leadCommonPropertiesDisplay);

    this.updateFilteredUsedInSite();
    // helpful for debugging during development
    // console.log(this.usedInSite);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // update filtered object whenever usedInSite or searchText changes
    if (changes.usedInSite || changes.searchText) {
      this.updateFilteredUsedInSite();
      this.updatefilteredValuesList();
      this.updateList();
      this.updateOriginalValues();
    }
  }

  /**
   * Build filteredUsedInSite object from usedInSite based on searchText.
   * - If searchText is empty, returns a shallow copy of usedInSite.
   * - Matches are case-insensitive against both key and value.
   */
  updateFilteredUsedInSite(): void {
    if (!this.usedInSite) {
      this.filteredUsedInSite = {};
      return;
    }

    const query = (this.searchText || '').toString().trim().toLowerCase();
    if (!query) {
      // show everything
      // ensure we provide an object (not reference) so template updates reliably
      this.filteredUsedInSite = Object.assign({}, this.usedInSite);
      return;
    }

    const out: any = {};
    try {
      const keys = Object.keys(this.usedInSite);
      for (const k of keys) {
        const v = this.usedInSite[k];
        const keyStr = (k || '').toString().toLowerCase();
        const valStr = (v || '').toString().toLowerCase();
        if (keyStr.indexOf(query) !== -1 || valStr.indexOf(query) !== -1) {
          out[k] = this.usedInSite[k];
        }
      }
    } catch (e) {
      // fallback: if usedInSite isn't a plain object, try to keep it empty
      this.filteredUsedInSite = {};
      return;
    }

    this.filteredUsedInSite = out;
  }

  setViewNew(view: 'Original' | 'basic'): void {
    this.activeViewNew = view;
  }



    updatefilteredValuesList(): void {
    if (!this.additionalSpec) {
      this.filteredAdditionalSpec = {};
      return;
    }

    const query = (this.searchText || '').toString().trim().toLowerCase();
    if (!query) {
      // show everything
      // ensure we provide an object (not reference) so template updates reliably
      this.filteredAdditionalSpec = Object.assign({}, this.additionalSpec);
      return;
    }

    const out: any = {};
    try {
      const keys = Object.keys(this.additionalSpec);
      for (const k of keys) {
        const v = this.additionalSpec[k];
        const keyStr = (k || '').toString().toLowerCase();
        const valStr = (v || '').toString().toLowerCase();
        if (keyStr.indexOf(query) !== -1 || valStr.indexOf(query) !== -1) {
          out[k] = this.additionalSpec[k];
        }
      }
    } catch (e) {
      // fallback: if usedInSite isn't a plain object, try to keep it empty
      this.filteredAdditionalSpec = {};
      return;
    }

    this.filteredAdditionalSpec = out;
  }


  updateList(): void {
    if (!this.valuesList) {
      this.filteredValuesList = {};
      return;
    }

    const query = (this.searchText || '').toString().trim().toLowerCase();
    if (!query) {
      // show everything
      // ensure we provide an object (not reference) so template updates reliably
      this.filteredValuesList = Object.assign({}, 
        this.valuesList);
      return;
    }

    const out: any = {};
    try {
      const keys = Object.keys(this.valuesList);
      for (const k of keys) {
        const v = this.valuesList[k];
        const keyStr = (k || '').toString().toLowerCase();
        const valStr = (v || '').toString().toLowerCase();
        if (keyStr.indexOf(query) !== -1 
        || valStr.indexOf(query) !== -1) {
          out[k] = this.valuesList[k];
        }
      }
    } catch (e) {
      // fallback: if usedInSite isn't a plain object, try to keep it empty
      this.filteredValuesList = {};
      return;
    }

    this.filteredValuesList = out;
  }

      updateOriginalValues(): void {
    if (!this.originalSpec) {
      this.originalSpec = {};
      return;
    }

    const query = (this.searchText || '').toString().trim().toLowerCase();
    if (!query) {
      // show everything
      // ensure we provide an object (not reference) so template updates reliably
      this.originalSpec = Object.assign({}, this.jsonRecieved);
      return;
    }

    const out: any = {};
    try {
      const keys = Object.keys(this.jsonRecieved);
      for (const k of keys) {
        const v = this.jsonRecieved[k];
        const keyStr = (k || '').toString().toLowerCase();
        const valStr = (v || '').toString().toLowerCase();
        if (keyStr.indexOf(query) !== -1 || valStr.indexOf(query) !== -1) {
          out[k] = this.jsonRecieved[k];
        }
      }
    } catch (e) {
      // fallback: if usedInSite isn't a plain object, try to keep it empty
      this.originalSpec = {};
      return;
    }

    this.originalSpec = out;
  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}


